import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import ApiService from "../../../core/service/ApiService";

export const AppointmentPaymentStatusInput = ({ row, onSuccess }) => {
    const { t } = useTranslation();
    const [data, setData] = useState({
        paymentStatus: 0
    });

    useEffect(() => {
        setData({
            paymentStatus: row.paymentStatus
        });
    }, [row]);

    const handleChange = async (value) => {
        setData({
            ...data,
            paymentStatus: value
        });

        const res = await ApiService.Accounting.UpdatePaymentStatus(row.appointmentId, value);

        if (res.success) {
            await onSuccess();
        }
    };

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <Select
                style={{ width: 200 }}
                size="small"
                //disabled={row?.confirmStatus === 2}
                value={data.paymentStatus}
                onChange={handleChange}
            >
                <Select.Option value={0} disabled>
                    {t('Balance')}
                </Select.Option>
                <Select.Option value={1}>
                    {t('Waiting')}
                </Select.Option>
                <Select.Option value={2} disabled>
                    {t('Done')}
                </Select.Option>
                <Select.Option value={3}>
                    {t('Reject')}
                </Select.Option>
            </Select>
        </div>
    );
};